import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-unauthenticated-content',
  template: `
    <div class="dx-card" style="width: 100%;height: 100%;">
      <ngx-spinner size="large" type="ball-scale-multiple" [fullScreen]="true">
        <p class="center-horizontal-vertical"> {{'loading' | translateWithFallback}} </p>
      </ngx-spinner>
    </div>
  `,
  styles: [`
    :host {
      width: 100%;
      height: 100%;
    }
  `]
})
export class UnauthenticatedContentComponent {

  constructor(private router: Router, private translateService: TranslateService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show();
  }

  ngOnDestroy(): void {
    this.spinner.hide();
  }

  get title() {
    const path = this.router.url.split('/')[1];
    switch (path) {
      case 'login':
        let translate = this.translateService.instant('login-sign-in-title');
        if(translate === 'login-sign-in-title') {
          return '?login-sign-in-title?';
        }
        return translate;
      default: return '';
    }
  }
}
